import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPilone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconPilone"><Path d="M8.61373 3.99452C8.95104 2.81394 10.0301 2 11.2579 2H12.7407C13.9685 2 15.0476 2.81394 15.3849 3.99452L16.815 9H7.18359L8.61373 3.99452Z" fill="currentColor"/><Path d="M6.75558 10.5L5.89844 13.5H18.1013L17.2442 10.5H6.75558Z" fill="currentColor"/><Path d="M18.53 15H5.46999L4.18427 19.5H2.75C2.33579 19.5 2 19.8358 2 20.25C2 20.6642 2.33579 21 2.75 21H21.25C21.6642 21 22 20.6642 22 20.25C22 19.8358 21.6642 19.5 21.25 19.5H19.8157L18.53 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPilone;
